module.exports = __webpack_public_path__ + "img/8.b73df84b.png";